import "./App.css";
import Weather from "./Weather";


export default function App() {
  return (
  
  <div className="App">
	  <div className="">
	  WeatherWise
	  
		  By EliCodes  <a href="https://github.com/elicodes89/weather-app" target="_blank" rel="noreferrer"
          > open-sourced on GitHub</a> 
		<Weather city= "Dalkeith" />
		</div>	  
    </div>
  );
}

